import { withGlobalHeaderLayout } from '@/features/shared/components/Headers/Layouts/GlobalHeaderLayout'
import { createServerSidePropsHandler } from '@/features/shared/serverUtils/ssrHelpers/createServerSidePropsHandler'
import { RouteName } from '@shared/constants/routes'
import { CMSLandingPage } from '@/features/cms/components/CMS/CMSLandingPage'
import { fetchCMSDataForBotSSR } from '@/features/cms/services/CMS/serverUtils'
import { applyGuestZipSSR } from '@/features/shared/serverUtils/storeResolutions/pagesAdapters'
import { getIsBot } from '@/features/shared/serverUtils/getIsBot'

export const getServerSideProps = createServerSidePropsHandler(
  RouteName.GLOBAL_LANDING_PAGE,

  async (pageDataParams) => {
    const {
      ssrContext,
      queryClient,
      authContext: { isGuestUser, isAuthenticated, isOnboarded },
      contextualRedirect,
    } = pageDataParams
    // Handles redirecting to welcome flow for authenticated users who have not onboarded
    if (isAuthenticated && !isOnboarded) {
      return contextualRedirect || {}
    }

    // If not logged in and no valid guest address cookie, try to set guest address zip
    if (!isGuestUser && !isAuthenticated) {
      const pageRedirect = await applyGuestZipSSR(ssrContext, queryClient)
      if (pageRedirect) return pageRedirect
    }
    if (getIsBot(ssrContext.req.headers)) {
      await fetchCMSDataForBotSSR({ pageParams: pageDataParams })
      return { props: { isBot: true } }
    }
    return {}
  },
)

export default withGlobalHeaderLayout(CMSLandingPage, { suppressFooter: true })
